import { sva } from "styled-system/css";

export const eventsRecipe = sva({
  slots: ["grid", "skeleton", "faderLeft", "faderRight"],
  base: {
    grid: {
      alignItems: "center",
      gridGap: "300",
      width: "full",
      maxWidth: "full",
      overflowX: "hidden",
    },
    skeleton: {
      w: "280px",
      h: "360px",
      minH: "160px",
      p: "0 !important",
      bg: "bg.lightest",
      borderColor: "border.light",
      borderStyle: "solid !important",
    },
    faderLeft: {
      position: "absolute",
      bottom: 0,
      left: 0,
      top: "-2px",
      w: "18px",
      background:
        "linear-gradient(270deg, rgba(239, 238, 235, 0.00) 0%, var(--wa-colors-cream-100) 87.1%)",
    },
    faderRight: {
      position: "absolute",
      bottom: 0,
      right: 0,
      top: "-2px",
      w: "18px",
      background:
        "linear-gradient(90deg, rgba(239, 238, 235, 0.00) 0%, var(--wa-colors-cream-100) 87.1%)",
    },
  },
  variants: {
    size: {
      mobile: {
        grid: {
          display: "flex !important",
          flexDir: "row",
          flexWrap: "nowrap",
          overflowX: "auto",
          pl: "150",
          pr: "300",
        },
      },
      tablet: {
        grid: {
          gridTemplateColumns: "1fr",
        },
        skeleton: {
          flexGrow: 1,
          w: "full",
          h: "160px",
        },
      },
      desktop: {
        grid: {
          gridTemplateColumns: "1fr 1fr",
        },
        skeleton: {
          flexGrow: 1,
          w: "full",
          h: "160px",
        },
      },
      large: {
        grid: {
          gridTemplateColumns: "1fr 1fr 1fr",
        },
        skeleton: {
          flexGrow: 1,
          w: "full",
          h: "160px",
        },
      },
    },
  },
  defaultVariants: {
    size: "mobile",
  },
});
